import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/firestore';
import 'firebase/functions';
import { devConfig, prodConfig } from './firebaseConfig'

const config = process.env.REACT_APP_MODE === 'prod' ? prodConfig : devConfig

class Firebase {
	constructor() {
		firebase.apps.length
			? firebase.app()
			: firebase.initializeApp(config);

		this.emailAuthProvider = firebase.auth.EmailAuthProvider;

		this.auth = firebase.auth()

		this.db = firebase.database();

		this.googleProvider = new firebase.auth.GoogleAuthProvider();

		this.facebookProvider = new firebase.auth.FacebookAuthProvider();

		this.twitterProvider = new firebase.auth.TwitterAuthProvider();

	}

	createUserWithEmailAndPassword = (email, password) =>
		this.auth.createUserWithEmailAndPassword(email, password);

	signInWithEmailAndPassword = (email, password) =>
		this.auth.signInWithEmailAndPassword(email, password);

	signInWithGoogle = () =>
		this.auth.signInWithPopup(this.googleProvider);

	signInWithFacebook = () =>
		this.auth.signInWithPopup(this.facebookProvider);

	signInWithTwitter = () =>
		this.auth.signInWithPopup(this.twitterProvider);

	signOut = () => this.auth.signOut();

	passwordReset = email => this.auth.sendPasswordResetEmail(email);

	passwordUpdate = password =>
		this.auth.currentUser.updatePassword(password);

	verifyPasswordReset = code => this.auth.verifyPasswordResetCode(code);

	confirmResetPassword = (code, password) => this.auth.confirmPasswordReset(code, password);

	verifyEmailAddress = code => this.auth.applyActionCode(code);

	user = uid => this.db.ref(`users/${uid}`);

	users = () => this.db.ref('users');
}

export default Firebase;
